import { message } from "antd";
import { getGlobal } from "apis/global";
import { patchUpdateUser, useGetUserById } from "apis/user";
import EmergencyContact from "components/EmergencyContact/EmergencyContact";
import React, { useEffect, useState } from "react";
import { getUserAuthObj } from "utils/auth";
import Locale from "react-intl-universal";

const EmergencyContactList = () => {
  const jwt = getUserAuthObj();

  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const { data: userInfo, refetch, isLoading: tableLoading } = useGetUserById(
    jwt._id
  );

  console.log("userInfo", tableLoading, userInfo);

  useEffect(() => {
    loadDefaultTemplate();
  }, []);

  // useEffect(() => {
  //   console.log("tableLoading", tableLoading);

  //   if (!tableLoading) {
  //     setTimeout(() => {
  //       setData(userInfo.contactList);
  //     }, 100);
  //   }
  //   return () => {};
  // }, [tableLoading]);

  const loadDefaultTemplate = async () => {
    try {
      setLoading(true);
      const res = await getGlobal();
      console.log(res, 23);
      if (res.data) {
        let buffer = [...res.data];
        buffer = buffer.map((item, index) => {
          return { ...item, _id: index };
        });

        console.log(buffer, "buffer");
        // setData(res.data);
        setData(buffer);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log("error", error);
    }
  };

  const handleUpdateGlobalDataOnChange = async (data) => {
    setLoading(true);
    const res = await patchUpdateUser(jwt._id, {
      contactList: [...data],
    });
    console.log(res);
    message.success("Data update successful");
    setLoading(false);
    refetch();
  };

  return (
    <div>
      <EmergencyContact
        data={
          // userInfo?.contactList && userInfo?.contactList.length > 0
          // userInfo ? userInfo.contactList : data
          userInfo && userInfo.contactList && userInfo.contactList.length > 0
            ? userInfo.contactList.map((item, index) => {
                return { ...item, _id: index };
              })
            : data
        }
        loading={loading || tableLoading}
        handleUpdateGlobalDataOnChange={handleUpdateGlobalDataOnChange}
        refetch={refetch}
      />
    </div>
  );
};

export default EmergencyContactList;
